const pickAggregatedFieldGroup = (source, keys) => {
  if (!source) return null;

  const fields = {};
  keys.forEach((key) => {
    if (source[key]) fields[key] = source[key];
  });

  return Object.keys(fields).length ? fields : null;
};

export const PRODUCT_CORE_FIELD_KEYS = [
  'title',
  'vendor',
  'productType',
  'category',
  'descriptionHtml',
  'status',
  'keywords',
];

export const PRODUCT_SEO_FIELD_KEYS = ['handle', 'seoTitle', 'seoDescription'];

export const PRICING_FIELD_KEYS = ['price', 'compareAtPrice', 'taxable', 'cost'];

export const PRODUCT_INVENTORY_FIELD_KEYS = ['sku', 'barcode'];

export const VARIANT_INVENTORY_FIELD_KEYS = ['sku', 'barcode', 'tracked'];

export const SHIPPING_FIELD_KEYS = [
  'requiresShipping',
  'weightValue',
  'weightUnit',
  'countryCodeOfOrigin',
  'harmonizedSystemCode',
];

export const pickProductCoreFields = (product) => (
  pickAggregatedFieldGroup(product, PRODUCT_CORE_FIELD_KEYS)
);

export const pickProductSeoFields = (product) => (
  pickAggregatedFieldGroup(product, PRODUCT_SEO_FIELD_KEYS)
);

export const pickPricingFields = (source) => (
  pickAggregatedFieldGroup(source, PRICING_FIELD_KEYS)
);

export const pickProductInventoryFields = (product) => (
  pickAggregatedFieldGroup(product, PRODUCT_INVENTORY_FIELD_KEYS)
);

export const pickVariantInventoryFields = (variant) => (
  pickAggregatedFieldGroup(variant, VARIANT_INVENTORY_FIELD_KEYS)
);

export const pickShippingFields = (source) => (
  pickAggregatedFieldGroup(source, SHIPPING_FIELD_KEYS)
);

export const pickMetaFields = (source) => source?.meta || null;

export default pickAggregatedFieldGroup;
